import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Form, Formik } from 'formik'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import {
  Typography,
  makeStyles,
  IconButton,
  InputAdornment,
} from '@material-ui/core'

import { SECONDARY } from 'app/constants/button'
import { passwordSchemaValidation } from 'commons/schemaValidation'

import LabelInput from 'app/componentV4/Labels/LabelInput'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import LinkToSignup from 'app/componentV4/Link/LinkToSignup'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

const useStyles = makeStyles({
  button: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
  input: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
})

const NewPassword = (props) => {
  const { onSubmit = () => {}, onBack = () => {} } = props
  const { formatMessage } = useIntl()
  const classes = useStyles()

  return (
    <PanelsIllustrationMSG isClickBack={true} onBack={() => onBack()}>
      <div className="flex justify-center items-center h-full">
        <div className="w-full space-y-10">
          {/* Header */}
          <Typography className="text-18 font-500 text-primary text-center">
            {'New user'}
          </Typography>

          <div className="flex items-center my-10">
            <div className="flex-1 border-t border-primary-350"></div>
            <Typography className="text-16 text-primary-300 text-center mx-5">
              {'Setup your password'}
            </Typography>
            <div className="flex-1 border-t border-primary-350"></div>
          </div>

          <Formik
            initialValues={{
              password: '',
              confirmPassword: '',
              isShowPassword: false,
              isShowConfirmPassword: false,
            }}
            validationSchema={passwordSchemaValidation(formatMessage)}
            onSubmit={async (values, { resetForm }) => {
              onSubmit(values)
              resetForm()
            }}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              setFieldValue,
            }) => (
              <Form className="space-y-10">
                <LabelInput
                  label={'Enter Password'}
                  required
                  className="w-full mb-0"
                >
                  <SimpleInput
                    className={classes.input}
                    type={values.isShowPassword ? 'text' : 'password'}
                    id="password-input"
                    name="password"
                    placeholder={'Enter Password'}
                    value={values.password}
                    size="medium"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setFieldValue(
                              'isShowPassword',
                              !values.isShowPassword,
                            )
                          }
                        >
                          {values.isShowPassword ? (
                            <Visibility
                              fontSize="small"
                              className="text-grey-200"
                            />
                          ) : (
                            <VisibilityOff
                              fontSize="small"
                              className="text-grey-200"
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    inputProps={{
                      'aria-label': 'Setup Password',
                    }}
                  />
                </LabelInput>

                <LabelInput
                  label={'Confirm Password'}
                  required
                  className="w-full mb-0"
                >
                  <SimpleInput
                    className={classes.input}
                    type={values.isShowConfirmPassword ? 'text' : 'password'}
                    id="confirm-password-input"
                    name="confirmPassword"
                    placeholder={'Confirm Password'}
                    value={values.confirmPassword}
                    size="medium"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setFieldValue(
                              'isShowConfirmPassword',
                              !values.isShowConfirmPassword,
                            )
                          }
                        >
                          {values.isShowConfirmPassword ? (
                            <Visibility
                              fontSize="small"
                              className="text-grey-200"
                            />
                          ) : (
                            <VisibilityOff
                              fontSize="small"
                              className="text-grey-200"
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    error={
                      touched.confirmPassword && Boolean(errors.confirmPassword)
                    }
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    inputProps={{
                      'aria-label': 'Setup Confirm Password',
                    }}
                  />
                </LabelInput>

                {/* Continue button */}
                <div className="flex justify-center mt-10">
                  <ContainedButton
                    type="submit"
                    color={SECONDARY}
                    className="w-full h-48"
                  >
                    {'Continue'}
                  </ContainedButton>
                </div>
              </Form>
            )}
          </Formik>

          <LinkToSignup />
        </div>
      </div>
    </PanelsIllustrationMSG>
  )
}

NewPassword.propTypes = {
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default NewPassword
